<template>
  <div>
    <div class="flex flex-between mb8">
      <div
        class="header-time-box"
        v-if="$store.state.role === 'school-role'"
      >申报时间：{{ startTime }}—{{ endTime }}</div>
      <div class v-else></div>
      <div
        class="add-btn"
        v-if="btnShow == true"
        @click="jumpPage(type)"
      >新增{{ type === "" ? "" : type }}</div>
    </div>
    <!-- 网络育人创新联盟：教育局角色筛选 -->
    <div v-if="alApplyJyjFilter" class="list-filter-panel">
      <div class="list-filter-row filter-dimension-grid">
        <div class="filter-dimension-block filter-dimension-block--primary">
          <div class="filter-dimension-title">大赛分组</div>
          <div class="filter-chip-list filter-chip-list--lg">
            <span
              class="filter-chip filter-chip--lg"
              :class="{ active: !params.levelType }"
              @click="setLevelFilter()"
            >全部</span>
            <span
              class="filter-chip filter-chip--lg"
              :class="{ active: params.levelType === '1' }"
              @click="setLevelFilter('1')"
            >中职组</span>
            <span
              class="filter-chip filter-chip--lg"
              :class="{ active: params.levelType === '2' }"
              @click="setLevelFilter('2')"
            >高职组</span>
          </div>
        </div>
        <!-- <div class="filter-dimension-block filter-dimension-block--primary">
          <div class="filter-dimension-title">团队类型</div>
          <div class="filter-chip-list filter-chip-list--lg">
            <span
              class="filter-chip filter-chip--lg"
              :class="{ active: !params.teamType }"
              @click="setTeamFilter()"
            >全部</span>
            <span
              class="filter-chip filter-chip--lg"
              :class="{ active: params.teamType === 'teacher' }"
              @click="setTeamFilter('teacher')"
            >教师团队</span>
            <span
              class="filter-chip filter-chip--lg"
              :class="{ active: params.teamType === 'student' }"
              @click="setTeamFilter('student')"
            >学生团队</span>
          </div>
        </div> -->
      </div>
      <div class="list-filter-row list-filter-fields-row">
        <div class="filter-field-item" v-if="$store.state.role !== 'education-role'">
          <span class="filter-field-label">省</span>
          <a-select
            :filterOption="filterOption"
            showSearch
            v-model="params.provincecode"
            allowClear
            placeholder="全部"
            style="width: 120px"
          >
            <a-select-option value>全部</a-select-option>
            <a-select-option
              v-for="(item, index) in provinceList"
              :key="index"
              :value="item.id"
            >{{ item.name }}</a-select-option>
          </a-select>
        </div>
        <div class="filter-field-item" v-if="$store.state.role === 'education-role'">
          <span class="filter-field-label">分社</span>
          <a-select
            v-model="params.branchName"
            allowClear
            showSearch
            :filterOption="filterOption"
            placeholder="全部"
            style="width: 150px"
          >
            <a-select-option value>全部</a-select-option>
            <a-select-option
              v-for="(item, index) in branchList"
              :key="index"
              :value="item"
            >{{ item }}</a-select-option>
          </a-select>
        </div>
        <div class="filter-field-item">
          <span class="filter-field-label">学校名称</span>
          <a-select
            style="width: 200px"
            allowClear
            show-search
            v-model="params.schoolName"
            placeholder="请输入学校名称"
            :default-active-first-option="false"
            :show-arrow="false"
            :filter-option="false"
            :not-found-content="null"
            @search="handleSearch"
            @change="change"
            @clear="handleClear"
          >
            <a-select-option v-for="d in schoollist" :key="d.name">{{ d.name }}</a-select-option>
          </a-select>
        </div>
        <div class="filter-field-item">
          <span class="filter-field-label">作品名称</span>
          <a-input
            v-model="params.zpname"
            placeholder="搜索作品名称"
            allowClear
            style="width: 150px"
          />
        </div>
        <div class="filter-field-item">
          <span class="filter-field-label">资料完整</span>
          <a-select
            v-model="params.Integrity"
            allowClear
            placeholder="全部"
            style="width: 120px"
          >
            <a-select-option value>全部</a-select-option>
            <a-select-option value="0">完整</a-select-option>
            <a-select-option value="1">未完整</a-select-option>
          </a-select>
        </div>
        <div class="filter-field-item">
          <span class="filter-field-label">提交状态</span>
          <a-select v-model="params.subState" allowClear placeholder="全部" style="width: 120px">
            <a-select-option value>全部</a-select-option>
            <a-select-option value="1">已提交</a-select-option>
            <a-select-option value="0">未提交</a-select-option>
          </a-select>
        </div>
      </div>
      <div class="list-filter-row list-filter-footer">
        <a-button  @click="resetAlApplyJyjFilter">重置筛选</a-button>
        <a-button type="primary"  @click="inquire()">查询</a-button>
      </div>
    </div>
    <div v-else class="header-search-box flex align-items-center border-box">
      <div class="flex-1 flex">
        <div
          class="flex align-items-center"
          v-if="$route.name == 'alApply' || $route.name == 'xal'"
        >
          <div>省：</div>
          <a-select default-value="全部" :filterOption="filterOption" showSearch v-model="params.provincecode" allowClear style="width: 120px">
            <a-select-option value>全部</a-select-option>
            <a-select-option
              v-for="(item, index) in provinceList"
              :key="index"
              :value="item.id"
            >{{ item.name }}</a-select-option>
          </a-select>
        </div>
        <div class="flex align-items-center" >
          <div>大赛分组：</div>
          <a-select default-value="全部" v-model="params.levelType"  allowClear style="width: 120px" >
            <a-select-option value>全部</a-select-option>
            <a-select-option value="1">中职</a-select-option>
            <a-select-option value="2">高职</a-select-option>
          </a-select>
        </div>
        <div class="flex align-items-center">
          <div>学校名称：</div>
          <a-input
            v-if="$route.name != 'alApply' &&  $route.name != 'xal'"
            v-model="params.schoolName"
            style="width: 150px"
            type="text"
            allowClear
          ></a-input>
          <a-select
            v-if="$route.name == 'alApply' ||  $route.name == 'xal'"
            style="width: 200px;"
            allowClear
            show-search
            v-model="params.schoolName"
            placeholder="请输入学校名称"
            :default-active-first-option="false"
            :show-arrow="false"
            :filter-option="false"
            :not-found-content="null"
            @search="handleSearch"
            @change="change"
            @clear="handleClear"
          >
            <a-select-option v-for="d in schoollist" :key="d.name">{{ d.name }}</a-select-option>
          </a-select>
        </div>
        <div class="flex align-items-center" v-if="$route.name == 'szStudio'">
          <!-- <div>{{ wokrName }}名称：</div> -->
          <div>课程名称：</div>
          <a-input v-model="params.name" style="width: 150px" type="text" allowClear></a-input>
        </div>
        <template v-if="$route.name == 'educationalBrand'">
          <div class="flex align-items-center">
            <div>工作室名称：</div>
            <a-input v-model="params.name" style="width: 150px" type="text" allowClear></a-input>
          </div>
          <div class="flex align-items-center">
            <div>主持人：</div>
            <a-input v-model="params.workroomName" style="width: 150px" type="text" allowClear></a-input>
          </div>
        </template>
        <div class="flex align-items-center">
          <div v-if="$route.name == 'alApply' ||  $route.name == 'xal'">作品名称：</div>
          <div v-else>作品名称：</div>
          <a-input v-model="params.zpname" style="width: 150px" type="text" allowClear></a-input>
        </div>
        <!-- <div class="flex align-items-center">
          <div>项目负责人：</div>
          <input
            v-model="params.projectPrincipal"
            class="input-style"
            type="text"
          />
        </div>-->
        <div class="flex align-items-center" v-if="$store.state.role != 'education-overall-role'">
          <div>资料完整：</div>
          <a-select default-value="全部" style="width: 120px" allowClear @change="handleChange">
            <a-select-option value>全部</a-select-option>
            <a-select-option value="0">完整</a-select-option>
            <a-select-option value="1">未完整</a-select-option>
          </a-select>
        </div>
        <div
          class="flex align-items-center"
          v-if="(($route.name == 'alApply' ||  $route.name == 'xal') && $store.state.role != 'education-overall-role')"
        >
          <div>提交状态：</div>
          <a-select style="width: 120px" v-model="params.subState" allowClear>
            <a-select-option value>全部</a-select-option>
            <a-select-option value="1">已提交</a-select-option>
            <a-select-option value="0">未提交</a-select-option>
          </a-select>
        </div>
      </div>
    </div>
    <div class="flex align-items-center">
      <div class="text1 flex-1" v-if="$route.name != 'alApply' &&  $route.name != 'xal'">
        当前共有
        <span class="color-red">{{ schoolCount }}</span>所学校,
        <span class="color-red">{{ applyCount }}</span>
        <template v-if="wokrName">个{{ wokrName }}</template>
        <template v-else>门课程</template>
      </div>
      <div class="text1 flex-1" v-if="$route.name == 'alApply' ||  $route.name == 'xal'">
        当前共有
        <template v-if="$store.state.role !== 'education-role'"><span class="color-red">{{ provinceCount }}</span>个省,</template>
        <span class="color-red">{{ applyCount }}</span>个作品
      </div>
      <div class="header-search-box flex flex-between">
        <!-- <div class="search-btn flex flex-center align-items-center" @click="inquire" v-if="$store.state.role != 'view-role'">
          <img class="img-box" src="@/assets/images/img48.png" alt />
          <div>查询</div>
        </div> -->
        <div class="search-btn flex flex-center align-items-center" v-if="$store.state.role != 'view-role'" @click="inquire(1)">
          <div>导出</div>
        </div>
        <div
          class="search-btn flex flex-center align-items-center"
          @click="inquire(2)"
          v-if="($route.name == 'alApply' || $route.name == 'xal') && $store.state.role != 'view-role'"
        >
          <div>导出分数</div>
        </div>
        <div class="search-btn flex flex-center align-items-center" v-if="$store.state.role != 'view-role'" @click="plsetRewards()">
          <div>设置奖项</div>
        </div>
      </div>
    </div>

    <div>
      <!---->
      <a-table
        :columns="columns"
        :locale="{ emptyText: '暂无数据' }"
        :data-source="data"
        :loading="loading"
        :pagination="pagination"
        @change="handleTableChange"
        :bordered="true"
        rowKey="id"
        :rowSelection="{
          selectedRowKeys:selectedRowKeys,
          onChange: handleSelectionChange,
          getCheckboxProps: getCheckboxProps
        }"
        :scroll="{ x: 1280 }"
      >
        <template slot="sequenceNumber" slot-scope="text, record, index">{{ index + 1 }}</template>
        <template slot="principals" slot-scope="text, record">
          <div
            style="cursor: pointer; color: #b25d24;font-weight: 600;"
            @click="previewDetail(record)"
          >{{ text }}</div>
        </template>
        <template slot="zpname" slot-scope="text, record">
          <div
            style="cursor: pointer; color: #b25d24;font-weight: 600;padding:0px 10px;"
            @click="previewDetail(record)"
          >{{ text }}</div>
        </template>
        <template slot="levelType" slot-scope="text">
          <div style="padding: 10px" v-if="text=='1'">中职组</div>
          <div style="padding: 10px" v-if="text=='2'">高职组</div>
        </template>
        <!-- <template slot="teamType" slot-scope="text">
          <div style="padding: 10px" v-if="text=='teacher'">教师团队</div>
          <div style="padding: 10px" v-if="text=='student'">学生团队</div>
          <div style="padding: 10px" v-else-if="!text || text === '-'">-</div>
        </template> -->
        <!--<template slot="zpname" slot-scope="text">
          <div style="padding: 10px">{{ text }}</div>
        </template>-->
        <template style="width: 100px" slot="applyFiles" slot-scope="text, record">
          <tr
            v-for="(item, index) in record.expertApplys"
            :key="index"
            :style="
              index + 1 == record.expertApplys.length
                ? ''
                : 'border-bottom: 1px solid #e8e8e8;'
            "
            class="table-tr"
          >
            <img
              class="ywcimg"
              v-if="(item.score && item.scoreFile) && (item.score != '-' || item.scoreFile != '-') "
              src="../../assets/images/ywc.png"
              alt
            />
            <div class="table-content" :title="item.expertName">
              <span>{{ item.expertName }}</span>
            </div>
          </tr>
          <span v-if="record.expertApplys.length == 0">-</span>
        </template>
        <template style="width: 100px" slot="score" slot-scope="text, record">
          <tr
            v-for="(item, index) in record.expertApplys"
            :key="index"
            :style="
              index + 1 == record.expertApplys.length
                ? ''
                : 'border-bottom: 1px solid #e8e8e8;'
            "
            class="table-tr"
          >
            <div class="table-content-score">{{ item.score }}</div>
          </tr>
          <span v-if="record.expertApplys.length == 0">-</span>
          <!-- {{text}}
          {{record.expertApplys}}-->
        </template>
        <template style="width: 100px" slot="examine" slot-scope="text, record">
          <tr
            v-for="(item, index) in record.expertApplys"
            :key="index"
            :style="
              index + 1 == record.expertApplys.length
                ? ''
                : 'border-bottom: 1px solid #e8e8e8;'
            "
            class="table-tr"
          >
            <div class="table-content-score">
              <div v-if="item.scoreFile == '-'">{{ item.scoreFile }}</div>
              <img
                v-else
                class="img-box-preview"
                src="../../assets/images/img51.png"
                alt
                style="cursor: pointer"
                @click="preview(item)"
              />
            </div>
          </tr>
          <span v-if="record.expertApplys.length == 0">-</span>
          <!-- {{text}}
          {{record.expertApplys}}-->
        </template>
        <!-- 工作室 实录视频 -->
        <template slot="duration" slot-scope="text, record">
          <div>
            <img
              v-if="
                (text / 1000 / 60) >= 4 &&
                (text / 1000 / 60) <= 5
              "
              class="img-box-hint"
              src="@/assets/images/img57.png"
              alt
              :title="getTime(text) + '\n时长合格'"
            />
            <img
              v-else
              class="img-box-hint"
              src="@/assets/images/img58.png"
              alt
              :title="
                text == '-'
                  ? `未上传实录视频`
                  : `${getTime(text)}\n视频时长不在4-5分钟内`
              "
            />
          </div>
        </template>
        <template slot="subState" slot-scope="text">
          <div v-if="text == 1">已提交</div>
          <div v-else>未提交</div>
        </template>
        <!-- 业务能力 实录视频 -->
        <template slot="duration" slot-scope="text">
          <img
            v-if="
              (text / 1000 / 60).toFixed(0) >= 8 && (text / 1000 / 60).toFixed(0) <= 15
            "
            class="img-box-hint"
            src="../../assets/images/img57.png"
            alt
            :title="getTime(text) + '\n时长合格'"
          />
          <img
            v-else
            class="img-box-hint"
            src="../../assets/images/img58.png"
            alt
            :title="
              text == '-'
                ? `未上传微课视频`
                : `${getTime(text)}\n视频时长不在8-15分钟内`
            "
          />
        </template>
        <template slot="duration1" slot-scope="text">
          <img
            v-if="
              (text / 1000 / 60).toFixed(0) >= 8 && (text / 1000 / 60).toFixed(0) <= 15
            "
            class="img-box-hint"
            src="../../assets/images/img57.png"
            alt
            :title="getTime(text) + '\n时长合格'"
          />
          <img
            v-else
            class="img-box-hint"
            src="../../assets/images/img58.png"
            alt
            :title="
              text == '-'
                ? `未上传微课视频`
                : `${getTime(text)}\n视频时长不在8-15分钟内`
            "
          />
        </template>
        <template slot="duration2" slot-scope="text">
          <img
            v-if="
              (text / 1000 / 60).toFixed(0) >= 8 && (text / 1000 / 60).toFixed(0) <= 15
            "
            class="img-box-hint"
            src="../../assets/images/img57.png"
            alt
            :title="getTime(text) + '\n时长合格'"
          />
          <img
            v-else
            class="img-box-hint"
            src="../../assets/images/img58.png"
            alt
            :title="
              text == '-'
                ? `未上传微课视频`
                : `${getTime(text)}\n视频时长不在8-15分钟内`
            "
          />
        </template>
        <template slot="duration3" slot-scope="text">
          <img
            v-if="
              (text / 1000 / 60).toFixed(0) >= 8 && (text / 1000 / 60).toFixed(0) <= 15
            "
            class="img-box-hint"
            src="../../assets/images/img57.png"
            alt
            :title="getTime(text) + '\n时长合格'"
          />
          <img
            v-else
            class="img-box-hint"
            src="../../assets/images/img58.png"
            alt
            :title="
              text == '-'
                ? `未上传微课视频`
                : `${getTime(text)}\n视频时长不在8-15分钟内`
            "
          />
        </template>

        <template slot="avgscore" slot-scope="text">
          <div>{{ text }}</div>
        </template>
        <template slot="izReview" slot-scope="text,record">
          <tr
            v-for="(item, index) in record.expertApplys"
            :key="index"
            :style="
              index + 1 == record.expertApplys.length
                ? ''
                : 'border-bottom: 1px solid #e8e8e8;'
            "
            class="table-tr"
          >
            <div class="table-content-score" style="width:100%;">
              <span
                v-if="item.izReview==1"
                style="cursor:pointer;color:#9A0B00;font-weight:600;"
                @click="reviewShow(record,item.expertUserId)"
              >已评审</span>
              <span v-else>未评审</span>
            </div>
          </tr>
          <span v-if="record.expertApplys.length == 0">-</span>
        </template>
        <template slot="applyFilesFull" slot-scope="text">
          <img
            v-if="text == 0"
            class="img-box-hint"
            src="../../assets/images/img57.png"
            alt
            title="资料完整"
          />
          <img v-else class="img-box-hint" src="../../assets/images/img58.png" alt title="资料不完整" />
        </template>
        <!-- <template slot="duration" slot-scope="text">
          <img
            v-if="
              (text / 1000 / 60) >= 5 &&
              (text / 1000 / 60) <= 10
            "
            class="img-box-hint"
            src="../../assets/images/img57.png"
            alt=""
            :title="getTime(text) + '\n时长合格'"
          />
          <img
            v-else
            class="img-box-hint"
            src="../../assets/images/img58.png"
            alt=""
            :title="
              text == '-'
                ? `未上传微课视频`
                : `${getTime(text)}\n视频时长不在5-10分钟内`
            "
          />
        </template>-->

        <span class="flex flex-around" slot="action" slot-scope="record" style="margin: 0 10px">
          <!--<div
            class="flex align-items-center"
            style="cursor: pointer"
            @click="editInfo(record)"
          >
            <img
              class="img-box-preview"
              src="../../assets/images/img51.png"
              alt=""
            />
            <span>预览</span>
          </div>-->
          <div
            class="flex align-items-center"
            style="cursor: pointer;margin-right:18px;"
            v-if="record.subState=='1'"
            @click="cancell(record)"
          >
            <!--<img
              class="img-box-preview"
              src="../../assets/images/img42.png"
              alt=""
            />-->
            <span style="color:rgb(211 44 6);text-decoration: underline;">驳回</span>
          </div>
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            v-if="record.subState=='1'"
            @click="showModal(record)"
          >
            <!--<img
              class="img-box-preview"
              src="../../assets/images/img42.png"
              alt=""
            />-->
            <span style="color:rgb(211 44 6);text-decoration: underline;">设置奖项</span>
          </div>
        </span>
      </a-table>
    </div>
    <preview-img v-if="visibles" ref="views"></preview-img>
    <div class="preview-pop-box" v-if="showPreviewPop">
      <div :class="fullscreen ? 'preview-box-fullscreen' : 'preview-box'">
        <preview
          type="education"
          @goNewPage="goNewPage"
          @closePreview="showPreviewPop = false"
          :preViewData="preViewData"
        ></preview>
      </div>
    </div>
    <div class="preview-pop-box" v-if="isshow">
      <div class="preview-box">
        <!--<expertlist
          :preViewData="preViewData"
          :expertUserId="expertUserId"
          @closePreview="isshow = false"
        ></expertlist>-->
        <expertdata
          :preViewData="preViewData"
          :expertUserId="expertUserId"
          @closePreview="isshow = false"
        ></expertdata>
      </div>
    </div>
    <a-modal
      title
      :visible="showDeleteModel"
      ok-text="确认"
      cancel-text="取消"
      @ok="handleOk"
      @cancel="showDeleteModel = false"
    >
      <p>您确定驳回吗?</p>
    </a-modal>
    <a-modal
      title="设置奖项"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="handleOks"
      @cancel="handleCancels"
      :cancelText="'取消'"
      :okText="'确定'"
    >
    <a-form-model
    ref="ruleForm"
    :model="form"
    :rules="rules"
    :label-col="labelCol"
    :wrapper-col="wrapperCol"
  >
    <a-form-model-item label="设置奖项" prop="region">
      <a-select v-model="form.region" placeholder="请选择设置的奖项">
        <a-select-option v-for="(item,index) in optionlist"  :key="index" :value="item.value">
          {{item.label}}
        </a-select-option>
        <!-- <a-select-option value="beijing">
          Zone two
        </a-select-option> -->
      </a-select>
    </a-form-model-item>
  </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import Preview from "./preview.vue";
import previewImg from "../previewImg.vue";
import expertlist from "./expertList";
import expertdata from "./expertData";
import { formatDuring } from "../../utils/time";
import { getAction, mhSchool, postAction, lxDrawResultBranchNames } from "@/api/index";
const columns = [
  {
    title: "序号",
    dataIndex: "sequenceNumber",
    id: "sequenceNumber",
    align: "center",
    scopedSlots: { customRender: "sequenceNumber" },
    width: 75,
    fixed: "left"
  },
  {
    title: "课程名称",
    dataIndex: "name",
    id: "name",
    align: "center",
    scopedSlots: { customRender: "name" },
    width: 240
  },
  {
    title: "作品名称",
    dataIndex: "zpname",
    id: "zpname",
    align: "center",
    width: 150
  },
  {
    title: "学校",
    dataIndex: "realname",
    id: "realname",
    align: "center",
    width: 240,
    scopedSlots: { customRender: "realname" }
  },
  {
    title: "负责人",
    dataIndex: "principals",
    id: "principals",
    align: "center",
    width: 150
  },
  {
    title: "联系电话",
    dataIndex: "phone",
    id: "phone",
    align: "center",
    width: 100
  },
  {
    title: "比赛视频1",
    dataIndex: "duration",
    id: "duration",
    align: "center",
    scopedSlots: { customRender: "duration" },
    width: 100
  },
  {
    title: "比赛视频2",
    dataIndex: "duration1",
    id: "duration1",
    align: "center",
    scopedSlots: { customRender: "duration1" },
    width: 100
  },
  {
    title: "比赛视频3",
    dataIndex: "duration2",
    id: "duration2",
    align: "center",
    scopedSlots: { customRender: "duration2" },
    width: 100
  },
  {
    title: "比赛视频4",
    dataIndex: "duration2",
    id: "duration2",
    align: "center",
    scopedSlots: { customRender: "duration2" },
    width: 100
  },
  {
    title: "资料完整",
    dataIndex: "applyFilesFull",
    id: "applyFilesFull",
    align: "center",
    scopedSlots: { customRender: "applyFilesFull" },
    width: 100
  },
  {
    title: "评审专家",
    dataIndex: "applyFiles",
    id: "applyFiles",
    align: "center",
    scopedSlots: { customRender: "applyFiles" },
    width: 150,
    fixed: "right"
  },
  {
    title: "评分",
    dataIndex: "score",
    id: "score",
    align: "center",
    scopedSlots: { customRender: "score" },
    width: 70,
    fixed: "right"
  },
  {
    title: "评审表",
    dataIndex: "examine",
    id: "examine",
    align: "center",
    scopedSlots: { customRender: "examine" },
    width: 85,
    fixed: "right"
  },
  {
    title: "均分",
    dataIndex: "avgscore",
    id: "avgscore",
    align: "center",
    scopedSlots: { customRender: "avgscore" },
    width: 70,
    fixed: "right"
  }
  // {
  // title: "操作",
  // id: "action",
  // align: "center",
  // scopedSlots: { customRender: "action" },
  // },
];
export default {
  name: "",
  components: { Preview, previewImg, expertlist, expertdata },
  props: {
    columns: {
      type: Array,
      default: () => columns
    },
    loading: Boolean,
    dataList: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: ""
    },
    startTime: {
      type: String,
      default: ""
    },
    endTime: {
      type: String,
      default: ""
    },
    pagination: {
      type: Object
    },
    isadd: {
      type: Boolean
    },
    btnShow: {
      type: Boolean
    },
    wokrName: {
      type: String,
      default: ""
    },
    applyCount: {
      type: Number
    },
    schoolCount: {
      type: Number
    },
    provinceCount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      temp: {},
      data: [],
      // 查询条件
      params: {
        provincecode: "",
        branchName: "",
        subState: "",
        levelType: "",
        teamType: "",
        Integrity: "",
      },
      showDeleteModel: false,
      fullscreen: false,
      visibles: false,
      showPreviewPop: false,
      url: "",
      preViewData: null,
      queryParam: {},
      provinceList: [],
      branchList: [],
      timeout: "",
      schoollist: [],
      isshow: false,
      expertUserId: "",
      canceldata: {},
      // multipleSelection:[],
      selectedRowKeys: [],
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      form: {
        region: undefined,
      },
      rules: {
        region: [{ required: true, message: '请选择设置的奖项', trigger: 'change' }],
      },
      visible: false,
      confirmLoading: false,
      optionlist:[],
      id:'',
      isMul:true,
    };
  },
  computed: {
    alApplyJyjFilter() {
      return (
        (this.$route.name === "alApply" || this.$route.name === "xal") &&
        (this.$store.state.role === "education-role" || this.$store.state.role === "view-role")
      );
    },
  },
  watch: {
    dataList(newPrice) {
      this.data = newPrice;
    }
  },
  created() {
    if (this.$route.name == "alApply" || this.$route.name == "xal") {
      if (this.$store.state.role === "education-role") {
        this.getBranchList();
      } else {
        this.getProvince();
      }
    }
  },
  mounted() {
    //	console.log(this.columns);
    this.init();
    this.getsj();
  },
  methods: {
     filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    getsj(){
      getAction('/sys/ng-alain/getDictItems/award',{}).then((res) => {
        this.optionlist=res;
      });
    },
    plsetRewards(){
      if(this.selectedRowKeys.length=='0'){
        this.$message.error('请先选择作品，才能设置奖项');
        return false;
      }
      this.form.region=undefined;
      this.isMul=true;
      this.visible = true;
    },
    showModal(record) {
      this.id=record.id;
      this.isMul=false;
      this.form.region=undefined;
      this.visible = true;
    },
    handleOks(e) {
      // this.ModalText = 'The modal will be closed after two seconds';
      this.confirmLoading = true;
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let params={
            award:this.form.region,
          };
          if(this.isMul){
            params.ids=this.selectedRowKeys.join();
          }else{
            params.ids=this.id;
          }
          // console.log("2222222");
          postAction('/lx/lxApply/setAwardByIds',params).then((res) => {
              if(res.code=='200'){
                this.$message.success(res.message);
                setTimeout(() => {
                  this.visible = false;
                  this.confirmLoading = false;
                  this.selectedRowKeys=[];
                  this.inquire();
                }, 2000);
              }else{
                this.$message.error(res.message);
                this.confirmLoading = false;
              }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleCancels(e) {
      this.visible = false;
    },
    handleSelectionChange(val) {
      this.selectedRowKeys = val;
      // console.log(this.selectedRowKeys,"4444");
    },
    getCheckboxProps(record) {
      return {
        props: {
          disabled: record.subState!='1'
        }
      };
    },
    handleOk() {
      this.showDeleteModel = false;
      this.$emit("cancelApply", this.canceldata);
    },
    cancell(row) {
      this.showDeleteModel = true;
      this.canceldata = { id: row.id, subState: row.subState };
    },
    reviewShow(row, expertUserId) {
      this.isshow = true;
      this.preViewData = row;
      this.expertUserId = expertUserId;
    },
    handleSearch(value) {
      if (value != "") {
        this.searchSchool(value);
      }
    },
    searchSchool(value) {
      let that = this;
      if (that.timeout) {
        clearTimeout(that.timeout);
        this.schoollist = [];
        that.params.schoolName = "";
      }
      that.timeout = setTimeout(() => {
        let params = {
          name: value,
          provincecode: that.params.provincecode
        };
        mhSchool(params).then(res => {
          if (res.code == 200) {
            if (res.result.length > 0) {
              that.schoollist = res.result;
            } else {
              console.log(value);
              that.params.schoolName = value;
            }
            that.$forceUpdate();
          }
        });
      }, 1000);
    },
    handleClear() {
      this.params.schoolName = ""; // 清空选择
      this.schoollist = []; // 清空学校列表
      // 其他需要重置的数据...
    },
    getProvince() {
      getAction("/pcity/queryByPid", { pid: 0 }).then(res => {
        if (res.code == 200) {
          this.provinceList = res.result;
        }
      });
    },
    // 分社下拉选项：复用 lx/lxDrawResult/branchNames
    // 返回兼容：字符串数组 / { records:[...] } / 对象数组（branchName | name），统一压成名称数组
    getBranchList() {
      lxDrawResultBranchNames()
        .then(res => {
          if (res && (res.code === 200 || res.success)) {
            const result = res.result;
            let list = [];
            if (Array.isArray(result)) {
              list = result;
            } else if (result && Array.isArray(result.records)) {
              list = result.records;
            }
            this.branchList = list
              .map(item =>
                typeof item === "string" ? item : item.branchName || item.name || ""
              )
              .filter(v => !!v);
          }
        })
        .catch(e => {
          console.error("分社列表加载失败", e);
        });
    },
    getTime(time) {
      return formatDuring(time);
    },
    handleChange(value) {
      this.params.Integrity = value;
    },
    setLevelFilter(value) {
      this.params.levelType =
        value === undefined || value === null || value === "" ? "" : String(value);
      if (this.alApplyJyjFilter) this.inquire();
    },
    setTeamFilter(value) {
      this.params.teamType =
        value === undefined || value === null || value === "" ? "" : value;
      if (this.alApplyJyjFilter) this.inquire();
    },
    resetAlApplyJyjFilter() {
      this.params.provincecode = "";
      this.params.branchName = "";
      this.params.schoolName = "";
      this.params.zpname = "";
      this.params.Integrity = "";
      this.params.subState = "";
      this.params.levelType = "";
      this.params.teamType = "";
      this.schoollist = [];
      this.inquire();
    },
    change() {
      this.$forceUpdate();
    },
    init() {},
    mergecells(text, data, key, index) {
      if (index !== 0 && text == data[index - 1][key]) {
        return 0;
      }
      let rowSpan = 1; //判断下一行是否相等
      for (let i = index + 1; i < data.length; i++) {
        if (text !== data[i][key]) {
          break;
        }
        rowSpan++;
      }
      return rowSpan;
    },
    jumpPage(type) {
      if (type === "") {
        let isAgree = window.localStorage.getItem("isAgree");
        if (isAgree === "true") {
          let applyType = 0;
          if (this.$route.name === "szStudio") {
            applyType = 1;
          } else if (this.$route.name === "educationalBrand") {
            applyType = 2;
          } else {
            applyType = 3;
          }
          this.$emit("showAddPops", applyType);
          setTimeout(() => {
            if (this.$parent.isadd == true) {
              this.$router.push({
                name: `${this.$route.name}DataUpload`,
                params: {
                  applyType
                }
              });
            } else {
              this.$message.warning("本学校上报数据已达上限");
            }
          }, 100);
        } else {
          this.$router.push({ name: `${this.$route.name}LetterCommitment` });
        }
      } else {
        this.$emit("showAddPop", type);
      }
    },
    inquire(type) {
      const pagination = {
        current: 1,
        pageSize: 20
      };
      this.handleTableChange(pagination, type);
    },
    confirm(e, row) {
      this.deleteInfo(row);
    },
    handleTableChange(pagination, type) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      // let queryParam = {};
      this.queryParam.page = pagination.current;
      this.queryParam.size = pagination.pageSize;
      this.queryParam.realname = this.params.schoolName;
      this.queryParam.principals = this.params.workroomName;
      // this.queryParam.principals = this.params.projectPrincipal;
      this.queryParam.name = this.params.name;
      this.queryParam.zpname = this.params.zpname;
      this.queryParam.provincecode = this.params.provincecode;
      this.queryParam.branchName = this.params.branchName;
      this.queryParam.Integrity = this.params.Integrity;
      this.queryParam.subState = this.params.subState;
      this.queryParam.levelType = this.params.levelType;
      // this.queryParam.teamType = this.params.teamType;
      if(this.selectedRowKeys.length>0){
        this.params.id = this.selectedRowKeys.join(',');
      }
      // this.queryParam
      if (type === 1) {
        this.$emit("lxApplyExportZip", this.params);
      } else if (type === 2) {
        this.$emit("lxApplyExportExcel", this.params);
      } else {
        this.$emit("getLxApplyjyjApplylist", this.queryParam);
      }
      this.init();
    },
    deleteInfo(row) {
      this.$emit("deleteApply", row.id);
    },
    editInfo(row) {
      this.$emit("editInfo", row, "preview");
    },
    rowSpan(key) {
      let arr = this.data
        .reduce((result, item) => {
          if (result.indexOf(item[key]) < 0) {
            result.push(item[key]);
          }
          return result;
        }, [])
        .reduce((result, keys) => {
          const children = this.data.filter(item => item[key] === keys);
          result = result.concat(
            children.map((item, index) => ({
              ...item,
              [`${key}RowSpan`]: index === 0 ? children.length : 0
            }))
          );
          return result;
        }, []);
      this.data = arr;
    },
    goNewPage(flag) {
      console.log(flag);
      this.fullscreen = flag;
    },
    preview(item) {
      this.visibles = true;
      this.$nextTick(() => {
        this.$refs.views.init(item.scoreFile);
      });
    },
    handleCancel() {
      this.visibles = false;
    },
    previewDetail(item) {
      this.preViewData = item;
      this.showPreviewPop = true;
    }
  }
};
</script>

<style scoped lang="scss">
.add-btn {
  width: 102px;
  height: 30px;
  line-height: 28px;
  text-align: center;
  background: #9A0B00;
  border-radius: 10px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}
.mb8 {
  margin-bottom: 8px;
}
.img-box {
  width: 18px;
  height: 18px;
  margin-right: 9px;
}
.img-box-hint {
  width: 18px;
  height: 18px;
  margin-right: 9px;
  display: inline-block;
  margin: 0 auto;
}
.img-box-preview {
  width: 21px;
  height: 21px;
  margin-right: 9px;
}

.table-box {
  text-align: center;
}
.list-filter-panel {
  margin-bottom: 14px;
  padding: 14px 16px;
  background: #f8faff;
  border: 1px solid #d6e4ff;
  border-radius: 10px;
}
.list-filter-row {
  margin-bottom: 12px;
}
.list-filter-row:last-child {
  margin-bottom: 0;
}
.list-filter-fields-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px 24px;
}
.filter-field-item {
  display: flex;
  align-items: center;
  gap: 8px;
}
.filter-field-label {
  flex-shrink: 0;
  font-size: 14px;
  font-weight: 600;
  color: #333;
}
.filter-dimension-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}
.filter-dimension-block {
  padding: 12px 16px;
  background: #fff;
  border: 1px solid #e6eefc;
  border-radius: 8px;
}
.filter-dimension-block--primary {
  border-color: #b8d4ff;
  background: linear-gradient(180deg, #fff 0%, #f3f8ff 100%);
  box-shadow: 0 1px 4px rgba(0, 90, 245, 0.08);
}
.filter-dimension-title {
  margin-bottom: 10px;
  padding-bottom: 8px;
  font-size: 15px;
  font-weight: 600;
  color: #1a1a1a;
  border-bottom: 1px solid #eef3fc;
}
.filter-dimension-block--primary .filter-dimension-title {
  color: #9A0B00;
  border-bottom-color: #d6e4ff;
}
.filter-chip-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.filter-chip-list--lg {
  gap: 10px;
}
.filter-chip {
  display: inline-block;
  min-width: 72px;
  padding: 6px 16px;
  font-size: 14px;
  text-align: center;
  color: #555;
  background: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  user-select: none;
  transition: all 0.2s;
}
.filter-chip--lg {
  min-width: 96px;
  padding: 8px 22px;
  border-radius: 8px;
}
.filter-chip:hover {
  color: #9A0B00;
  border-color: #91b8ff;
}
.filter-chip.active {
  color: #fff;
  background: #9A0B00;
  border-color: #9A0B00;
  font-weight: 600;
  box-shadow: 0 2px 6px rgba(0, 90, 245, 0.25);
}
.list-filter-footer {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  padding-top: 14px;
  border-top: 1px dashed #e0e0e0;
}
@media (max-width: 768px) {
  .filter-dimension-grid {
    grid-template-columns: 1fr;
  }
}
.header-search-box {
  font-size: 14px;
  padding-left: 7px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #383838;
  margin-top: 10px;
  margin-bottom: 15px;
  .flex .flex {
    margin-right: 10px;
  }
  // .input-style {
  //   width: 140px;
  //   height: 30px;
  //   border: 1px solid #d9d9d9;
  //   border-radius: 5px;
  //   padding: 8px 12px;
  //   margin: 0 20px 0 6px;
  // }
  .search-btn {
    width: 100px;
    height: 30px;
    line-height: 30px;
    cursor: pointer;
    text-align: center;
    color: #fff;
    background: #9A0B00;
    border-radius: 6px;
    margin-left: 10px;
    margin-right: 20px;
    .img-box {
      width: 12px;
      height: 14px;
      margin-right: 8px;
    }
  }
}
.header-time-box {
  width: 363px;
  height: 32px;
  line-height: 30px;
  text-align: center;
  background: #b7d1ff;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #9A0B00;
  border-radius: 10px;
}
.color-red {
  color: #9A0B00;
}
.text1 {
  margin: 18px 0 11px 0;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
}
.table-content {
  /* margin: 20px 0; */
  /* text-align: center; */
  /* float: right; */
  margin: 0 auto;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.table-content-score {
  width: 50px;
  overflow: hidden;
  white-space: nowrap;
  /* margin: 20px 0; */
  /* text-align: center; */
  overflow: hidden;
  text-overflow: ellipsis;
  /* float: right; */
  margin: 0 auto;
  height: 60px;
  line-height: 60px;
}
.table-tr {
  width: 100%;
  display: inline-block;
  text-align: center;
  margin: 0 auto;
  // border-bottom: 1px solid #e8e8e8;
}
/deep/.ant-table-tbody > tr > td:nth-child(5) {
  padding: 0 !important;
  // overflow-wrap: break-word;
}
/deep/.ant-table-tbody > tr > td {
  padding: 0 !important;
  height: 60px;
}
.preview-pop-box {
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  .preview-box {
    margin: 50px auto;
    width: 1177px;
    height: 90%;
  }
  .preview-box-fullscreen {
    width: 100vw;
    height: 100vh;
  }
}
/deep/ .table-tr {
  position: relative;
  .ywcimg {
    width: 50px;
    height: 50px;
    position: absolute;
    top: 0;
    left: 0;
  }
}
</style>
